import { useLocation } from "react-router-dom";
import { navItems } from "../../config";
import { LoadingGif } from "../../assets/images";

export const LoggingIn = () => {
        const location = useLocation();
    
        const isActive = (path: string) => path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);
        
        if (!navItems.some((item) => isActive(item.route)))
            return null;

    return <>
        <div className="d-flex align-items-center">
            <img className="mr-1" src={LoadingGif} alt="..." height={24} width={24}/>
            <h2 className="text-center">Iniciando sesión...</h2>
        </div>
        <p className="my-1 mx-3">
            Para que <b>ALSE</b> pueda ser <b>gratis</b>💵 apagamos los servidores cuando nadie los usa🌙
        </p>
        <p className="my-1 mx-3">
            Eso significa que <b>esto podría tardar hasta 2 minutos</b>⏱️ mientras que se encienden los servidores
        </p>
        <p className="my-1 mx-3">
            Gracias por tu paciencia y por darnos una oportunidad 🧡
        </p>
    </>
}